import { styled } from '@mui/material/styles'
import { TableCell, TableRow as MuiTableRow } from '@mui/material'
import theme from 'lib/theme'

export const HeaderTableCell = styled(TableCell, {
  shouldForwardProp: (props) => props !== 'minWidth' && props !== 'index',
})<{ minWidth: number; index: number }>(({ minWidth, index }) => ({
  minWidth,
  zIndex: index === 0 ? 3 : 1,
  left: 0,
  textTransform: 'uppercase',
  transition: '0.2s ease-in-out margin-left',
  fontSize: '10px',
  fontWeight: 'bold',
  color: theme.palette.text.secondary,
  borderBottom: `1px solid ${theme.palette.neutral.grey7}`,
  '&.MuiTableCell-root': {
    padding: theme.spacing(1),
  },
}))

export const BodyTableCell = styled(TableCell, {
  shouldForwardProp: (props) =>
    props !== 'index' &&
    props !== 'selected' &&
    props !== 'cellWidth' &&
    props !== 'alignTop',
})<{
  index: number
  selected?: boolean
  cellWidth?: string
  alignTop?: boolean
}>(({ index, selected, cellWidth, alignTop }) => ({
  verticalAlign: alignTop ? 'top' : 'center',
  width: cellWidth || 'auto',
  position: index === 0 ? 'sticky' : 'relative',
  zIndex: index === 0 ? 2 : 0,
  left: 0,
  backgroundColor: selected ? theme.palette.action.selected : 'inherit',
  textTransform: 'capitalize',
  fontWeight: index === 0 ? 'bold' : 'normal',
  borderBottom: `1px solid ${theme.palette.neutral.grey7}`,
}))

export const TableRow = styled(MuiTableRow, {
  shouldForwardProp: (props) =>
    props !== 'productTable' &&
    props !== 'discountProduct' &&
    props !== 'highlighted',
})<{ productTable: boolean; discountProduct: boolean; highlighted?: boolean }>(
  ({ productTable, discountProduct, highlighted }) => ({
    backgroundColor: highlighted
      ? theme.palette.action.selected
      : theme.palette.commonColors.white,
    '.MuiTableCell-root': {
      padding: productTable ? '0px' : theme.spacing(2),
      borderBottom: discountProduct
        ? `2px solid ${theme.palette.neutral.grey2}`
        : `1px solid ${theme.palette.neutral.grey7}`,
    },
    '&:hover': !productTable && {
      cursor: 'pointer',
      backgroundColor: theme.palette.action.hover,
      '.MuiTableCell-root:first-of-type': {
        color: theme.palette.primary.main,
      },
    },
  })
)
